export default __webpack_public_path__ + "static/media/Group 1284Yono@2x.3aae6aac.png";